import { Popover as RACPopover, type PopoverProps } from "react-aria-components";
import { cx } from "../tv";

/** Elevation level "popover" (DESIGN-RULES 4): one shadow token, solid surface, 240 ms in. */
export const popoverCls = ({ isEntering, isExiting }: { isEntering: boolean; isExiting: boolean }) =>
  cx(
    "z-(--z-dropdown) min-w-(--trigger-width) overflow-hidden rounded-lg bg-panel-solid shadow-pop outline-none",
    "origin-(--trigger-anchor-point)",
    isEntering && "animate-[os-pop-in_var(--dur-slow)_var(--ease-out)]",
    isExiting && "animate-[os-pop-out_var(--dur-fast)_var(--ease-out)]",
  );

export function Popover({ className, offset = 6, ...props }: Omit<PopoverProps, "className"> & { className?: string }) {
  return <RACPopover offset={offset} {...props} className={(v) => cx(popoverCls(v), className)} />;
}
